import { render, staticRenderFns } from "./company_referrals.vue?vue&type=template&id=082657e0&scoped=true"
import script from "./company_referrals.vue?vue&type=script&lang=js"
export * from "./company_referrals.vue?vue&type=script&lang=js"
import style0 from "./company_referrals.vue?vue&type=style&index=0&id=082657e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082657e0",
  null
  
)

export default component.exports